export default {

  methods: {
    isTenantTypeMenu(type) {
      if (type == null) {
        return true
      }
      let currentTenantType = this.getTenantType()
      return currentTenantType === type
    },

    isAuthorized(roles) {
      let currentUser = JSON.parse(localStorage.currentUser);

      if (typeof roles === 'string') {
        return currentUser.roles.includes(roles);
      } else {
        if (roles.length === 0) {
          return true
        }

        for (let role of currentUser.roles) {
          if (roles.includes(role)) {
            return true;
          }
        }

        return false;
      }
    },

    getTenant() {
      let currentUser = JSON.parse(localStorage.currentUser);
      if (currentUser.tenant) {
        return currentUser.tenant
      } else {
        return null
      }
    },

    getTenantType() {
      let currentUser = JSON.parse(localStorage.currentUser);
      if (currentUser.tenantType) {
        return currentUser.tenantType
      } else {
        return null
      }
    },

  }
};
